export const getHexWithOpacity = (hex: string, opacity: number = 1) => {
  if (/^#[0-9A-F]{6}$/i.test(hex)) {
    return hex + getHexOpacity(opacity);
  }

  return hex;
};

export const getHexOpacity = (opacity: number) => {
  return (Math.round(opacity * 255) + 0x10000)
    .toString(16)
    .slice(-2)
    .toUpperCase();
};

export const hexToRgb = (hex: string) => {
  if (!hex?.length) {
    return undefined;
  }

  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

  hex = hex.replace(shorthandRegex, (_, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result && result.length > 3
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : undefined;
};

export const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
};

const colorChannelMixer = (
  colorA: number,
  colorB: number,
  amountToMix: number
) => {
  const channelA = colorA * amountToMix;
  const channelB = colorB * (1 - amountToMix);

  return Math.floor(channelA + channelB);
};

export const colorMixer = (
  rgbA: [number, number, number],
  rgbB: [number, number, number],
  amountToMix: number
) => {
  if (amountToMix > 1) amountToMix = 1;
  if (amountToMix < 0) amountToMix = 0;

  const r = colorChannelMixer(rgbA[0], rgbB[0], amountToMix);
  const g = colorChannelMixer(rgbA[1], rgbB[1], amountToMix);
  const b = colorChannelMixer(rgbA[2], rgbB[2], amountToMix);

  return rgbToHex(r, g, b);
};
